import { fetchFromOldApi } from '~/services/Http';

import { PasswordData } from '../useLegacyChangePassword';

export const putChangePassword = async (
  json: PasswordData,
  userName: string,
) => {
  return await fetchFromOldApi(
    '/form/user/' + encodeURIComponent(userName) + '/password',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json),
    },
  )
    .then((r) => r.json())
    .then((r) => r.fLoginSuccess);
};
